import React from "react";
import { Link } from "react-router-dom";
import { brand } from "../data/siteData";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footerWrap" style={{ marginTop: "10px" }}>

      <div className="container footerRow">

        {/* LOGO + TAGLINE */}
        <div className="footerCol">
          <img style={{ height: "100px", marginLeft: "78px", marginBottom: "20px", borderRadius: "11px" }} src="/images/scorivaLogo.jpg" alt="Scoriva Logo" />
          {/* <h2 className="footerBrand">{brand.name}</h2> */}
          <p className="footerText">
            {t("footer.tagline")}
          </p>

          {/* ⭐ Sosial media iconları */}
          <div className="socialIcons">
            <a href="" target="_blank" rel="noreferrer">
              <i style={{ display: "flex" }} className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/scoriva.az/" target="_blank" rel="noreferrer">
              <i style={{ display: "flex" }} className="fab fa-instagram"></i>
            </a>
            <a href="" target="_blank" rel="noreferrer">
              <i style={{ display: "flex" }} className="fab fa-linkedin-in"></i>
            </a>
            <a href="" target="_blank" rel="noreferrer">
              <i style={{ display: "flex" }} className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        {/* PAGES */}
        <div className="footerCol">
          <h4 className="footerTitle">{t("footer.pages")}</h4>
          <ul className="footerList">
            <li><Link to="/">{t("home")}</Link></li>
            <li><Link to="/haqqimizda">{t("about")}</Link></li>
            <li><Link to="/mehsullar">{t("products")}</Link></li>
            <li><Link to="/blog">{t("blog")}</Link></li>
            <li><Link to="/elaqe">{t("contact")}</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footerCol">
          <h4 className="footerTitle">{t("footer.contact")}</h4>
          <ul className="footerList footerContact">
            <li>
              <i className="fa-solid fa-phone footerIcon" aria-hidden="true"></i>
              <span>+994 60 211 34 35</span>
            </li>

            <li>
              <i className="fa-solid fa-envelope footerIcon" aria-hidden="true"></i>
              <span>info@scoriva.net</span>
            </li>

            <li>
              <i className="fa-solid fa-location-dot footerIcon" aria-hidden="true"></i>
              <span>{t("footer.baku")}</span>
              {/* əgər sən düz mətn yazmaq istəyirsənsə:
      <span>Naxçıvan, Azərbaycan</span>
      */}
            </li>
          </ul>
        </div>


      </div>

      {/* COPYRIGHT */}
      <div className="footerBottom">
        © {new Date().getFullYear()} {brand.name}. {t("footer.rights")}
      </div>

      {/* CSS — dəyişməyib */}
      <style>{`
        .footerWrap {
          background: #002244;
          color: #fff;
          font-family: Arial, sans-serif;
          padding: 35px 0 15px;
        }
.footerContact li{
  display: flex;
  align-items: center;
  gap: 10px;
}
/* Mobil: bütün footer content mərkəzdə */
@media (max-width: 768px){
  .footerRow{
    grid-template-columns: 1fr;   /* 3 sütun -> 1 sütun */
    text-align: center;          /* başlıqlar və linklər ortada */
    justify-items: center;       /* grid item-lar ortada */
    gap: 26px;
  }

  .footerCol{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;         /* hər sütunun içi ortada */
  }

  /* logo da ortada olsun */
  .footerCol img{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  /* listlər ortada, soldan padding olmasın */
  .footerList{
    padding: 0;
    margin: 0;
  }

  .footerList li{
    margin-bottom: 10px;
  }

  /* Əlaqə hissəsində ikon+mətn də ortada */
  .footerContact li{
    justify-content: center;     /* ✅ icon+text birlikdə ortada */
  }
}

.footerIcon{
  color: #fff;          /* ağ icon */
  font-size: 14px;
  opacity: 0.95;
  width: 18px;          /* hamısı eyni düzülüş üçün */
  text-align: center;
  flex: 0 0 18px;
}

        .footerRow {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 30px;
        }

        .footerBrand {
          font-size: 22px;
          font-weight: 900;
          margin-bottom: 8px;
        }

        .footerText {
          font-size: 14px;
          opacity: 0.8;
          margin-bottom: 15px;
        }

.socialIcons { align-items: center; }

.socialIcons a{
  display: inline-flex;
  line-height: 0;
}

.socialIcons i{
  display: block;
  line-height: 1;
}

        .footerTitle {
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .footerList {
          list-style: none;
          padding: 0;
          font-size: 14px;
        }

        .footerList li {
          margin-bottom: 6px;
          opacity: 0.85;
        }

        .footerList a {
          color: #fff;
          text-decoration: none;
        }

        .footerList a:hover {
          opacity: 0.6;
        }

        .footerBottom {
          text-align: center;
          margin-top: 20px;
          padding-top: 10px;
          border-top: 1px solid rgba(255,255,255,0.15);
          font-size: 13px;
          opacity: 0.7;
        }
      `}</style>

      {/* FontAwesome CDN */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
      />
    </footer>
  );
}
